<section>
  <datalist id="listfuncionarios">
    <select>
      <option *ngFor="let item of funcionarios" [value]="item.nome"></option>
    </select>
  </datalist>
</section>

<div class="row">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">
        <div class="divider"></div>

        <div class="form-row">
          <div class="col-md-4">
            <form novalidate [formGroup]="formEmpreiteira" id="form" hidden>
              <label class="col-md-4 col-form-label">Empreiteira</label>
              <div class="col-md-8">
                <select
                  class="form-control"
                  formControlName="empreiteiraId"
                  value=""
                >
                  <option *ngFor="let e of empreiteiras" value="{{ e.id }}">
                    {{ e.nome }}
                  </option>
                </select>
                <section
                  *ngIf="this.empreiteiraIdEmpty"
                  class="form-text text-danger pl-2"
                >
                  <small>Selecione a Empreiteira</small>
                </section>
              </div>
            </form>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="areaTecnicaId">Área Técnica</label>
              <select
                class="form-control"
                (change)="
                  changeAreaTecnica(
                    $event.target.value,
                    $event.target.selectedOptions[0].text
                  )
                "
              >
                <option value="0" selected>Todas as áreas técnicas</option>
                <option *ngFor="let t of areasTecnicas" [value]="t.id">
                  {{ t.nome }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="this.spvs?.length > 0">
          <div class="col-md-6 d-flex justify-content-md-start">
            <span class="text-muted">Clique no SS ou PT a ser qualificado</span>
          </div>
          <div class="col-md-6 d-flex justify-content-md-end">
            <span class="text-muted"
              >Selecionar
              <span (click)="selecionarTodos()" class="txt-blue cp">Todos</span>
              /
              <span (click)="selecionarNenhum()" class="txt-blue cp"
                >Nenhum</span
              ></span
            >
          </div>
        </div>

        <div class="divider"></div>

        <section style="height: 460px">
          <div *ngIf="this.spvs?.length > 0" class="box-table h450">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tipo</th>
                  <th>Nº</th>
                  <th>Serviço Solicitado</th>
                  <th>Área Técnica</th>
                  <th>Requisitante</th>
                  <th>Ramal</th>
                  <th>Data Solicitação</th>
                </tr>
              </thead>
              <!-- (click)="getById(spv?.spvId, modal)" -->
              <tbody>
                <tr
                  *ngFor="let spv of this.spvs"
                  (click)="selecionarItem(spv?.spvId, modal)"
                  class="cp"
                  [ngClass]="{
                    'bg-danger': this.spv.irregularidadeId,
                    'tr-info': spv?.marcado && !this.spv.irregularidadeId
                  }"
                  [title]="spv.irregularidadeDescricao"
                >
                <td style="background-color: #fff;"><i class="fa fa-tags fa-lg text-danger" aria-hidden="true" *ngIf="this.spv.irregularidadeId"></i></td>
                  <td class="text-center fb">{{ spv?.tipo }}</td>
                  <td class="text-center">
                    {{ spv?.spvId | zerosEsquerda: 5 }}
                  </td>
                  <td>{{ spv?.servico }}</td>
                  <td class="text-center">{{ spv?.areaTecnicaDescricao }}</td>
                  <td class="text-center">{{ spv?.requisitante }}</td>
                  <td class="text-center">{{ spv?.contato }}</td>
                  <td class="text-center">
                    {{ spv?.dataHoraCadastro | date: "dd/MM/yyyy" }}
                  </td>
                </tr>
                <tr *ngFor="let v of this.voids">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <span class="d-flex justify-content-center">
              <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
            </span>
          </div>

          <div
            class="no-results mt-5 h450"
            *ngIf="this.spvs !== undefined && this.spvs?.length == 0"
          >
            <div class="swal2-icon swal2-success swal2-animate-success-icon">
              <div
                class="swal2-success-circular-line-left"
                style="background-color: rgb(255, 255, 255)"
              ></div>
              <span class="swal2-success-line-tip"></span
              ><span class="swal2-success-line-long"></span>
              <div class="swal2-success-ring"></div>
              <div
                class="swal2-success-fix"
                style="background-color: rgb(255, 255, 255)"
              ></div>
              <div
                class="swal2-success-circular-line-right"
                style="background-color: rgb(255, 255, 255)"
              ></div>
            </div>
            <div class="results-title">
              Nenhuma SS ou PT qualificada encontrada
            </div>
            <div class="results-title" *ngIf="this.filtroAreaTecnicaId != 0">
              <span>na Área Técnica {{ this.filtroAreaTecnicaDescricao }}</span>
            </div>
          </div>
        </section>
      </div>

      <div class="box-footer">
        <div class="footer-total">
          <span
            *ngIf="this.spvs !== undefined && this.spvs?.length > 0"
            class="pl-2 pt-1 pb-2"
            >Total :
            <b>{{ this.spvs?.length }}</b>
          </span>
          <span class="footer-selecionados" *ngIf="this.totalOSsAGerar > 0">
            Total selecionados: <b>{{ this.totalOSsAGerar }}</b>
          </span>
        </div>

        <div class="footer-legenda">
         
          <div>
              <i class="fa fa-tags fa-lg text-danger" aria-hidden="true"></i> 
              <span>
                indica a existência de pendência
            </span>
          </div>
        </div>

        <div class="footer-buttons">
          <button
            type="button"
            class="btn btn-light"
            (click)="selecionarNenhum()"
            [disabled]="!this.totalOSsAGerar"
          >
            Desistir
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="programar(modal)"
            [disabled]="!this.totalOSsAGerar || this.spvsMarcados?.length === 0"
          >
            Programar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"
                ><img src="./assets/images/homePeq.png"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modal let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4
      class="modal-title"
      *ngIf="this.spvsMarcados.length == 1 && !this.someItemAvaliado"
    >
      Programar Serviço {{ this.spvSelecionada.tipo }} N°
      <b>{{ this.spvSelecionada?.spvId | zerosEsquerda: 5 }}</b>
    </h4>
    <h4
      class="modal-title"
      *ngIf="this.spvsMarcados.length > 1 || this.someItemAvaliado"
    >
      Programar Serviços
    </h4>
  </div>
  <div class="modal-body">
    <div class="tarja-aviso" *ngIf="this.someItemAvaliado">
      <p>
        <b><i class="fa fa-warning pr-2"></i>Atenção: </b> um ou mais itens que você selecionou, assinalado(s) abaixo, já foi(ram)
        programado(s) ou marcado com pendência por outro usuário
      </p>
    </div>

    <form novalidate [formGroup]="form" (validSubmit)="submit()">
      <section
        *ngIf="
          (this.spvsMarcados.length == 1 || this.itemComPendencia) &&
          !this.someItemAvaliado
        "
      >
        <div class="position-relative row form-group">
          <label class="col-md-2 col-form-label">Requisitante</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.requisitante }}"
              disabled
            />
          </div>
          <label class="col-md-2 col-form-label">Ramal</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.contato }}"
              disabled
            />
          </div>
        </div>

        <div class="position-relative row form-group">
          <label class="col-md-2 col-form-label">Local de Trabalho</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.localDeTrabalho }}"
              disabled
            />
          </div>
          <label class="col-md-2 col-form-label">Área Técnica</label>
          <div class="col-md-4">
            <select
              class="form-control"
              id="areaTecnicaId"
              tabindex="-1"
              formControlName="areaTecnicaId"
            >
              <option
                *ngFor="let t of areasTecnicas"
                [selected]="t.id == this.spvSelecionada?.areaTecnicaId"
                [value]="t.id"
              >
                {{ t.nome }}
              </option>
            </select>
          </div>
        </div>

        <div class="position-relative row form-group">
          <label class="col-md-2 col-form-label">Equipamento</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.equipamento }}"
              disabled
            />
          </div>
          <label class="col-md-2 col-form-label">Tipo de OS</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.tipoOSStr }}"
              disabled
            />
          </div>
        </div>

        <div class="position-relative row form-group">
          <label class="col-md-2 col-form-label">Prioridade</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.prioridadeStr }}"
              disabled
            />
          </div>
          <label class="col-md-2 col-form-label">Área Restrita</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.areaRestritaStr }}"
              disabled
            />
          </div>
        </div>

        <div class="position-relative row form-group">
          <label class="col-md-2 col-form-label">Fim de semana</label>
          <div class="col-md-4 msg-invalid">
            <select
              class="form-control"
              tabindex="-1"
              formControlName="fimDeSemana"
            >
              <option value="null">selecione</option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
          </div>

          <label class="col-md-2 col-form-label">Empreiteira</label>
          <div class="col-md-4">
            <input
              class="form-control"
              type="text"
              value="{{ this.spvSelecionada?.empreiteiraStr }}"
              disabled
            />
          </div>
        </div>

        <div class="position-relative row form-group">
          <label class="col-md-2 col-form-label">Serviço Solicitado</label>
          <div class="col-md-10">
            <textarea
              rows="2"
              class="form-control"
              value="{{ this.spvSelecionada?.servicoSolicitado }}"
              disabled
            ></textarea>
          </div>
        </div>

        <div class="divisor"></div>
      </section>

      <section
        *ngIf="
          (this.spvsMarcados.length > 1 && !this.itemComPendencia) ||
          this.someItemAvaliado
        "
      >
        <div class="divisor" *ngIf="!this.someItemAvaliado">
          <p>SSs ou PTs selecionados</p>
        </div>

        <section>
          <div class="box-table" style="height: 260px">
            <table>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Nº</th>
                  <th>Serviço Solicitado</th>
                  <th>Área Técnica</th>
                  <th>Requisitante</th>
                  <th>Ramal</th>
                  <th>Data Solicitação</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let spv of this.spvsMarcados"
                  class="cp"
                  [ngClass]="{
                    'bg-danger': this.spv.irregularidadeId != null,
                    'tarja-aviso': spv.qualificado
                  }"
                  [title]="spv.irregularidadeDescricao"
                >
                  <td class="text-center fb">{{ spv?.tipo }}</td>
                  <td class="text-center">
                    {{ spv?.spvId | zerosEsquerda: 5 }}
                  </td>
                  <td>{{ spv?.servico }}</td>
                  <td class="text-center">{{ spv?.areaTecnicaDescricao }}</td>
                  <td class="text-center">{{ spv?.requisitante }}</td>
                  <td class="text-center">{{ spv?.contato }}</td>
                  <td class="text-center">
                    {{ spv?.dataHoraCadastro | date: "dd/MM/yyyy" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </section>

      <section
        style="
          border: 1px solid #ddd;
          margin-top: 15px;
          overflow-y: scroll;
          overflow-x: hidden;
        "
        *ngIf="this.autorizacaoAdicionarFoto && !this.someItemAvaliado"
      >
        <div class="form-row text-center" style="padding: 0 5px">
          <div
            class="col-md-12 fb fs11"
            style="background-color: #eee; padding: 12px"
          >
            Registro fotográfico
          </div>
        </div>

        <div
          class="row showImagens"
          style="padding-bottom: 20px; height: 150px"
        >
          <div class="col-md-2" *ngFor="let pview of previewsPhotos">
            <div>
              <img
                [src]="pview.dataUrl"
                class="zoom cp"
                (click)="openModalExibePhoto(modalExibePhoto, pview)"
              />
            </div>
          </div>
        </div>
      </section>

      <section *ngIf="(this.spvsMarcados?.length > 1 && !this.someItemAvaliado)">
        <div class="divisor">
          <p>Valores para todos os itens selecionados</p>
        </div>

        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="">Área Técnica</label>
              <select
                class="form-control"
                id="areaTecnicaIdTodos"
                tabindex="-1"
                formControlName="areaTecnicaId"
              >
                <option value="">selecione</option>
                <option *ngFor="let t of areasTecnicas" [value]="t.id">
                  {{ t.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="">Fim de Semana</label>
              <select
                class="form-control"
                tabindex="-1"
                formControlName="fimDeSemana"
              >
                <option value="null">selecione</option>
                <option value="true">SIM</option>
                <option value="false">NÃO</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      <section *ngIf="!this.someItemAvaliado">
        <div class="form-row">
          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="centroDeCusto">Engenheiro responsável</label>
              <select
                class="form-control"
                formControlName="engenheiroResponsavelId"
                tabindex="-1"
              >
                <option value="">selecione</option>
                <option *ngFor="let e of this.engenheiros" value="{{ e.id }}">
                  {{ e.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="encarregadoResponsavelId"
                >Responsável OS</label
              >
              <select
                class="form-control"
                formControlName="encarregadoResponsavelId"
              >
                <option value="">selecione</option>
                <option *ngFor="let e of this.encarregados" value="{{ e.id }}">
                  {{ e.nome }}
                </option>
              </select>
              <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                <small
                  *ngIf="
                    form
                      .get('encarregadoResponsavelId')
                      .hasError('isNotValidEncarregadoResponsavel')
                  "
                  >O Responsável OS deve ser informado</small
                >
              </section>
            </div>
          </div>
          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="tipoProgramacao">Tipo de Programação</label>
              <select
                class="form-control"
                formControlName="tipoProgramacao"
              >
                <option value="1">Execução de serviço</option>
                <option value="2">Avaliação de serviço</option>
               
              </select>
            </div>
          </div>


        </div>

        <div class="form-row">
          <div class="col-md-9">
            <div class="position-relative form-group">
              <label for="observacoesGerais">Observações Gerais</label>
              <textarea
                rows="3"
                class="form-control"
                formControlName="observacoesGerais"
                style="resize: none"
              ></textarea>
            </div>
          </div>

          <div class="col-md-3">
            <button
              class="btn btn-secondary btn-shadow btn-block btn-bottom"
              type="button"
              style="display: block"
              [disabled]="
                !this.autorizacoes?.podeIncluir ||
                this.form.get('irregularidadeId').value != ''
              "
              (click)="openModalChecklist(modalchecklist)"
              title="Informar Check List do SS"
            >
              <i class="fa fa-plus pull-left pt-1"> </i> Checklist
              <span
                *ngIf="this.spvsAprovadosCheckLists?.length > 0"
                class="badge badge-pill badge-warning pull-right pt-1"
                >{{ this.spvsAprovadosCheckLists?.length }}</span
              >
            </button>
            <button
              class="btn btn-secondary btn-shadow btn-block btn-bottom"
              type="button"
              [disabled]="
                !this.autorizacoes?.podeIncluir ||
                this.form.get('irregularidadeId').value != ''
              "
              (click)="openModalColaboradores(modalcolaboradores)"
              title="Informar Colaboradores do SS"
            >
              <i class="fa fa-plus pull-left pt-1"></i>Colaboradores
              <span
                *ngIf="this.funcionariosSelecionados?.length > 0"
                class="badge badge-pill badge-warning pull-right pt-1"
                >{{ this.funcionariosSelecionados?.length }}</span
              >
            </button>
          </div>
        </div>
      </section>

      <div class="row" style="border-top: 2px solid #ddd; padding-top: 15px">
        <div class="col-md-6">
          <div
            class="row form-group"
            *ngIf="(this.spvsMarcados.length == 1 || this.itemComPendencia) && !this.someItemAvaliado"
          >
            <label class="col-md-4 col-form-label">Situação de pendência</label>
            <div class="col-md-8">
              <select
                class="form-control"
                tabindex="-1"
                formControlName="irregularidadeId"
                [ngClass]="{
                  'bg-danger': this.form.get('irregularidadeId').value != ''
                }"
                (change)="changeSituacaoPendencia()"
              >
                <option value="">Nenhuma pendência</option>
                <option *ngFor="let t of irregularidades" [value]="t.id">
                  {{ t.descricao }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-secondary btn-shadow btn-block"
            (click)="fecharModal()"
          >
            <span *ngIf="this.someItemAvaliado">OK</span>
            <span *ngIf="!this.someItemAvaliado">Desistir</span>
          </button>
        </div>

        <div class="col-md-3">
          <button
            type="submit"
            class="btn btn-primary btn-shadow btn-block"
            [disabled]="
              (this.isProcessing ||
              !this.autorizacoes?.podeIncluir ||
              this.someItemAvaliado
              )
            "
          >
            <span><i class="fa fa-plus pull-left pt-1"></i>Confirmar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!-- **************************************************** -->

<ng-template #modalchecklist let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Informar Checklist</h4>
  </div>
  <div
    class="modal-body pt-0 mt-0 tarja-edit"
    style="display: block; overflow-y: scroll; height: 515px"
  >
    <div *ngFor="let tcl of tiposCheckLists">
      <div class="alert alert-secondary pl-3 mt-3 txt-blue">
        <i class="fa fa-bookmark fb pr-2"></i>
        {{ tcl.descricao }}
      </div>
      <div
        *ngFor="let cl of tcl.checksLists"
        class="alert alert-light ml-2 pl-3"
      >
        <div class="custom-checkbox custom-control">
          <input
            class="form-check-input cp"
            type="checkbox"
            (click)="adicionarRemoverCheckLists(cl.id)"
            [checked]="checkListJaAdicionado(cl.id)"
            style="height: 15px; width: 15px"
          />
          <label
            class="form-check-label"
            for=""
            [ngClass]="{ fb: checkListJaAdicionado(cl.id) }"
          >
            {{ cl.item }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="display: inline">
    <div class="row">
      <div class="col-md-6 text-left">
        <span class="mt-2 pl-2"
          ><b>{{ this.spvsAprovadosCheckLists?.length }}</b> selecionados</span
        >
      </div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-secondary pl-5 pr-5 mr-2 btn-shadow"
            (click)="c('Close click')"
          >
            {{
              this.spvsAprovadosCheckLists?.length > 0 ? "Confirmar" : "Fechar"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- ************************************************************* -->

<ng-template #modalcolaboradores let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Informar colaboradores</h4>
  </div>

  <div class="modal-body pt-0 mt-0 tarja-edit">
    <div class="row">
      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue fb">Lista de funcionários</span><br />
        </div>

        <div class="divider"></div>
        <div class="text-center">
          <span class="text-muted fs09"
            ><i class="fa fa-search"></i> Pesquisa por <b>parte do nome</b> ou
            <b>matrícula</b> do funcionário</span
          >
        </div>
        <div class="input-group mt-3">
          <input
            type="text"
            class="form-control"
            list="listfuncionarios"
            id="datalistFuncionarios"
            maxlength="40"
            (change)="changeDataListFuncionarios($event.target.value)"
          />
          <div
            class="input-group-append cp"
            (click)="limparDataListFuncionarios()"
            title="limpar campo e recarregar lista completa de opções"
          >
            <span class="input-group-text"><i class="fa fa-trash"></i></span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="text-center mb-2">
          <span class="text-muted"
            >Selecione um ou mais na lista e confirme</span
          >
        </div>

        <div class="divider"></div>

        <div class="box-table-sm fs09" style="height: 327px">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Matrícula</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let f of funcionariosListaGrid"
                (click)="selectColaborador(f.id)"
                class="alert cp"
                [ngClass]="{ 'tr-info': f.marcado }"
              >
                <td>{{ f.nome }}</td>
                <td class="text-center">{{ f.matricula }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-start mt-2">
          <span
            *ngIf="this.funcionariosListaGrid.length < this.funcionarios.length"
          >
            Total funcionários (filtrados) :
          </span>
          <span
            *ngIf="
              this.funcionariosListaGrid.length == this.funcionarios.length
            "
          >
            Total funcionários :
          </span>
          <span
            ><b>{{ this.funcionariosListaGrid.length }}</b></span
          >
        </div>
      </div>

      <div class="col-md-2 text-center">
        <button
          class="btn cp"
          (click)="adicionarColaboradores()"
          style="margin-top: 270px"
          title="Confirmar colaboradores selecionados"
        >
          <img src="./assets/images/arrow-right.png" /></button
        ><br />
        <span class="text-muted txt-blue fs09">confirmar</span>
      </div>

      <div class="col-md-5">
        <div class="text-center mt-3">
          <span class="txt-blue fb db">Lista de colaboradores informados</span
          ><br />
        </div>
        <div class="divider"></div>

        <div class="box-table fs09" style="height: 470px">
          <table>
            <thead>
              <tr>
                <th>Nome</th>
                <th>Matrícula</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of funcionariosSelecionados">
                <td>{{ f.nome }}</td>
                <td class="text-center">{{ f.matricula }}</td>

                <td class="text-center w40">
                  <button
                    class="btn btn-sm"
                    (click)="removerColaborador(f)"
                    title="remover da lista"
                  >
                    <i class="fa fa-trash text-secoundary"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end">
          <span class="mt-2"
            >Total de colabores informados :
            <b>{{ this.funcionariosSelecionados?.length }}</b>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-2">
    <div class="col-md-8"></div>
    <div class="col-md-4">
      <button
        type="button"
        class="btn btn-secondary btn-block"
        (click)="c('Close click')"
      >
        {{ this.funcionariosSelecionados?.length > 0 ? "Confirmar" : "Fechar" }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalExibePhoto let-c="close" let-d="dismiss">
  <div class="modal-body" style="padding: 0px; background-color: #141518">
    <div class="row">
      <div
        class="col-md-12 text-center"
        style="padding: 10px; background: #141518"
      >
        <img [src]="previewPhotoSelecionada.dataUrl" class="img-thumbnail" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" style="padding: 10px; background: #141518">
      <div class="text-right">
        <button
          type="button"
          class="btn btn-secondary pl-5 pr-5 mr-4"
          (click)="c('Close click')"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- ************************************************************* -->
